<template>
  <v-container fluid>
    <main-header-plat-a-pat />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-container class="mt-2">
      <v-card>
        <v-row class="fill-height">
          <v-col>
            <v-sheet height="64">
              <v-toolbar flat>
                <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"> Hoy </v-btn>
                <v-btn fab text small color="grey darken-2" @click="prev">
                  <v-icon small> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn fab text small color="grey darken-2" @click="next">
                  <v-icon small> mdi-chevron-right </v-icon>
                </v-btn>
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right> mdi-menu-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="type = 'day'">
                      <v-list-item-title>Dia</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'week'">
                      <v-list-item-title>Semana</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = 'month'">
                      <v-list-item-title>Mes</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="type = '4day'">
                      <v-list-item-title>4 dias</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="1200">
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="calendarEvents"
                :event-color="getEventColor"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                @change="updateRange"
                first-time="04:00"
                :interval-count="20"
              ></v-calendar>

              <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x
                min-width="550px"
              >
                <v-card color="grey lighten-4" width="550px" flat>
                  <v-toolbar :color="selectedEvent.color" dark>
                    <span class="text-h6 ml-2">{{ selectedEvent.name }}</span>
                  </v-toolbar>

                  <v-card-text>
                    <v-form v-if="currentlyEditing !== selectedEvent.id" class="ml-4">
                      <p v-if="selectedEvent.name?.includes('Sesión')">
                        <b>Profesional de la Salud Mental:</b>
                        {{ selectedEvent.instProfesName }}
                      </p>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatAppointmentsAPage',
  components: {
    MainHeaderPlatAPat,
    MainHeaderPlatB,
    VOverlayLoader,
    VSnackBar,
  },
  data: () => ({
    today: new Date().toISOString().substring(0, 10),
    focus: new Date().toISOString().substring(0, 10),
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Dia',
      '4day': '4 Dias',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
    names: ['Sesión', 'Académico', 'Laboral', 'Viaje', 'Ocupado', 'Libre', 'Feriado'],
    name: null,
    color: '#1976D2',
    nPro: '',
    nameProfes: '',
    start: null,
    end: null,
    dialog: false,
    dialogVerif: false,
    loading: false,
    otp: '',
    text: '',
    currentlyEditing: null,
    show1: true,
  }),
  mounted() {
    this.loadSchema();
    this.loadEvents();
    this.getEvents();
    this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters('patAppointmentsAPage', ['schema', 'catEventType', 'events', 'status', 'dataNameProfes']),
    ...mapGetters('notifications', ['snackbar']),

    calendarEvents() {
      if (!this.events || !this.catEventType) return [];

      return this.events.map(event => {
        const type = this.catEventType.find(t => t.event_type_id == event.name);
        
        return {
          ...event,
          name: type ? type.event_type : event.name 
        };
      });
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },

    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      });
    },
  },
  methods: {
    ...mapActions('patAppointmentsAPage', [
      'loadSchema',
      'loadEvents',
      'updateEvents',
      'delEvents',
      'verifPro',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),
    async onFinish() {
      this.loading = true;

      let model = {};
      if (this.nPro === '' || this.nPro === null) {
        model.nPro = this.selectedEvent.nPro;
      } else {
        model.nPro = this.nPro;
      }
      model.otp = this.otp;

      this.$store.dispatch('patAppointmentsAPage/verifPro', { model }).then(
        () => {
          if (this.status === true) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'PIN de Usuario es correcto';
            }, 500);
            this.otp = '';
            this.text = '';

            if (this.dataNameProfes) {
              if (this.nPro === '' || this.nPro === null) {
                this.selectedEvent.nameProfes = this.dataNameProfes;
              } else {
                this.nameProfes = this.dataNameProfes;
              }
            } else {
              if (this.nPro === '' || this.nPro === null) {
                this.selectedEvent.nameProfes = '';
              } else {
                this.nameProfes = '';
              }
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackNoPatient;
            }
            this.dialogVerif = false;
          } else if (this.status === false) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'PIN de Usuario es incorrecto';
            }, 500);
          }
        },
        () => {
          setTimeout(() => {
            this.loading = false;
            this.text = 'PIN de Usuario es incorrecto';
            this.nameProfes = '';
          }, 500);
        }
      );
      this.otp = '';
      this.text = ' ';
    },
    async getEvents() {
      this.nameProfes = '';

      await this.loadEvents();
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const toDatetimeLocal = (date) => {
        const pad = (n) => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };

      this.start = start instanceof Date && !isNaN(start) ? toDatetimeLocal(start) : '';
      this.end = end instanceof Date && !isNaN(end) ? toDatetimeLocal(end) : '';
    },
  },
};
</script>
